
import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRoute, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import { CachedDataService } from '@services/data/cached-data.service';
import { ScreenService } from '@services/screen.service';
import { ObjectsService } from '@services/http/objects.service';
@Injectable()
export class MainGuard implements CanActivate {
  currentUrl: String = null;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private screenService: ScreenService,
    private objectsService: ObjectsService,
    private cachedDataService: CachedDataService) {
    objectsService.updateObjects.subscribe(() => {

    });
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.cachedDataService.getExpiredDate()) {
      this.cachedDataService.clearCache();
      this.router.navigate(['/signin']);
      return false;
    }
    if (this.cachedDataService.isAuth()) {
      if (this.cachedDataService.getCurrentUser() && !this.cachedDataService.getCurrentUser().phoneNumberConfirmed) {
        this.screenService.isShowLoader = false;
        this.router.navigate(['/signup']);
        return false;
      } else {
        if (!this.cachedDataService.getObservableObjects() || this.cachedDataService.getObservableObjects().length === 0) {
          this.router.navigate(['/personal', this.cachedDataService.getCurrentUser().id]);
          return false;
        }
        return true;
      }
    } else {
      this.router.navigate(['/signin']);
      return false;
    }

  }
}






// WEBPACK FOOTER //
// ./src/app/guards/main.guard.ts